export default "__VITE_ASSET__CEgI$gYv__"